const PurchaseSupplierHeader = [
  {
    group: "Pedido",
    columns: [
      {
        name: "",
        id: "pedido-id",
        show: false,
      },
      {
        name: "",
        id: "pedido-color",
        show: false,
      },
      {
        name: "Status da Entrega",
        id: "pedido-status",
        show: true,
      },

      {
        name: "Número pedido",
        id: "pedido-numero",
        show: true,
      },
      {
        name: "Centro",
        id: "pedido-centro",
        show: true,
      },
    ],
  },
  {
    group: "Quantidade",
    columns: [
      {
        name: "Total",
        id: "quantidade-total",
        show: true,
      },
      {
        name: "Entregue",
        id: "quantidade-entregue",
        show: true,
      },
      {
        name: "Pendente",
        id: "quantidade-pendente",
        show: true,
      },
      {
        name: "Agendada",
        id: "quantidade-agendada",
        show: true,
      },
      {
        name: "Pendente Agendamento",
        id: "quantidade-pedente-agendada",
        show: true,
      },
    ],
  },
  {
    group: "Data",
    columns: [
      {
        name: "Prevista",
        id: "data-prevista",
        show: true,
      },
    ],
  },
];

export default PurchaseSupplierHeader;
